// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__2w9Vv","srOnly":"Input_srOnly__RBj5f","textarea":"Input_textarea__2BfCa","placeholder":"Input_placeholder__llSCe","charCount":"Input_charCount__vAnHv"};